import { actions } from '.';

export function getIterationsSucceed(payload, options) {
  return {
    type: actions.GET_ITERATIONS_SUCCEED,
    payload,
    options
  };
}

export function setIterations(payload) {
  return {
    type: actions.SET_ITERATIONS,
    payload
  };
}
